import { render, staticRenderFns } from "./IndividualsContent.vue?vue&type=template&id=71420b02&scoped=true"
import script from "./IndividualsContent.vue?vue&type=script&lang=js"
export * from "./IndividualsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71420b02",
  null
  
)

export default component.exports